import getPartnerAsset, { DynamicAssetsKeys } from '../assets';
import { withLoader } from '../components/PageLoader';
import { PageId } from '../constants';
import ExperiencesPage from '../pages/experiences';
import ProfilePage from '../pages/profile';
import ValueCalculatorRedirect from '../pages/valcalcredirect';
import { RouteComponent } from './models';
import { composePage } from './utils';

export const internalRedirects = [
  {
    route: { exact: true, path: '/verizonprotecthome/en-us/' },
    toPath: '/',
  },
  {
    from: '*',
    toPath: '/'
  }
];

export const externalRedirects = [
  {
    route: { exact: true, path: '/' },
    url: 'https://www.asurion.com/verizon/home-device-protect/',
  },
  {
    route: { exact: true, path: '/whats-covered' },
    url: 'https://www.asurion.com/verizon/home-device-protect/whats-covered/',
  },
  {
    route: { exact: true, path: '/faq' },
    url: 'https://www.asurion.com/verizon/home-device-protect/',
  },
  {
    route: { exact: true, path: '/terms-conditions' },
    url: 'https://www.asurion.com/legal/verizon/',
  },
];

const routes: RouteComponent[] = [
  {
    Component: composePage({ pageId: PageId.Profile })(ProfilePage),
    route: { exact: true, path: '/profile' },
  },
  {
    Component: composePage({ pageId: PageId.ExpertSessions }, withLoader())(ExperiencesPage),
    route: { exact: false, path: getPartnerAsset(DynamicAssetsKeys.expertSessionsPath) },
  },
  {
    Component: composePage({ pageId: PageId.ValueCalcRedirect })(ValueCalculatorRedirect),
    route: { exact: true, path: '/calculator' },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./packages/smart-home-support/routes/TCH-WEB.ts